import Icon from "./Icon";

/*
  Figma "Inline message": an icon, a Subheadline Semibold title in the tone's
  colour and a Footnote body, for notes that sit inside a card or popup.
*/
const TONES = {
  info: { bg: "bg-message-info-bg", title: "text-message-info-title", icon: "info" },
  success: { bg: "bg-message-success-bg", title: "text-message-success-title", icon: "check" },
  warning: { bg: "bg-message-warning-bg", title: "text-message-warning-title", icon: "warning" },
  danger: { bg: "bg-message-danger-bg", title: "text-message-danger-title", icon: "warning" },
};

const InlineMessage = ({ tone = "info", icon, title, children, className = "" }) => {
  const look = TONES[tone];
  return (
    <div className={`flex gap-space-12 rounded-[22px] px-space-16 py-space-12 ${look.bg} ${className}`}>
      <span className={`shrink-0 ${look.title}`}>
        <Icon name={icon || look.icon} size={20} />
      </span>
      <div className="flex min-w-0 flex-1 flex-col gap-[2px]">
        {title && <p className={`text-subheadline-semibold ${look.title}`}>{title}</p>}
        <p className="text-footnote text-label-secondary">{children}</p>
      </div>
    </div>
  );
};

export default InlineMessage;
